<div class="component">
  <p>{{message | translate }}</p>
  <div class="btn-area center">
    <app-form-btn [css]="'save-btn'" [icon]="'fa-regular fa-check'" [label]="'common.ok'" (onClick)="onOk.emit()">
    </app-form-btn>
  </div>
</div>
